export const NAME_ASC = 1;
export const NAME_DESC = 2;
export const DATE_ASC = 3;
export const DATE_DESC = 4;